import Vue from "vue"
import VueRouter from "vue-router"
import NProgress from "nprogress"
import Home from "../views/Home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
  },
  {
    path: "/profile/overview",
    name: "overview",
    meta: {
      api: {
        type: "node",
        id: "2",
      },
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/ProfileOverview.vue")
    },
  },
  {
    path: "/profile/board-of-management",
    name: "board",
    meta: {
      api: [
        { type: "node", id: "63" },
        { type: "group", id: "person" },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/ProfileBoard.vue")
    },
  },

  {
    path: "/business-in-ekiti",
    name: "board",
    meta: {
      api: [{ type: "group", id: "db_item" }],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/BusinessInEkiti.vue")
    },
  },
  {
    path: "/tenders",
    name: "tenders",
    meta: {
      api: [
        { type: "node", id: "83" },
        { type: "group", id: "tender" },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Tenders.vue")
    },
  },
  {
    path: "/projects",
    name: "projects",
    meta: {
      api: [
        { type: "node", id: "243" },
        { type: "group", id: "project" },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Projects.vue")
    },
  },
  {
    path: "/contact-us",
    name: "contactus",
    meta: {
      api: [{ type: "node", id: "84" }],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/ContactUs.vue")
    },
  },
  {
    path: "/grievance-resolution",
    name: "grievanceresolution",
    meta: {
      api: [{ type: "node", id: "170" }],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/DisputeResolution.vue")
    },
  },
  {
    path: "/downloads",
    name: "downloads",
    meta: {
      api: [
        {
          type: "node",
          id: "130",
        },
        {
          type: "group",
          id: "downloads",
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Downloads.vue")
    },
  },
  {
    path: "/downloads/:id",
    name: "download",
    meta: {
      api: [
        {
          type: "node",
          id: "130",
        },
        {
          type: "group",
          id: "downloads",
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Download.vue")
    },
  },
  {
    path: "/ease-of-business",
    name: "whyekiti",
    meta: {
      api: [
        { type: "node", id: "44" },
        { type: "group", id: "sector" },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/EaseBusiness.vue")
    },
  },
  {
    path: "/flagship-projects",
    name: "opportunities",
    meta: {
      api: [
        {
          type: "group",
          id: "opportunity",
        },
      ],
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/FlagshipProjects.vue")
    },
  },
  {
    path: "/opportunity/:alias",
    name: "opportunity",

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Opportunity.vue")
    },
  },
  {
    path: "/invest/key-sectors",
    name: "sectors",
    meta: {
      api: {
        type: "group",
        id: "sector",
      },
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/KeySectors.vue")
    },
  },
  {
    path: "/sector/:alias",
    name: "sector",

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Sector.vue")
    },
  },
  {
    path: "/news/:alias",
    name: "news",

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/News.vue")
    },
  },
  {
    path: "/checklist",
    name: "checklist",
    meta: {
      api: {
        type: "node",
        id: "200",
      },
    },

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Checklist.vue")
    },
  },
  {
    path: "/application-submission",
    name: "submission",

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/ApplicationSubmission.vue")
    },
  },
  {
    path: "/media",
    name: "media",
    meta: {
      api: {
        type: "group",
        id: "news",
      },
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/Media.vue")
    },
  },
  {
    path: "/*",
    name: "notfound",

    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function() {
      return import(/* webpackChunkName: "about" */ "../views/NotFound.vue")
    },
  },
  // {
  //   path: "/profile/our-values",
  //   name: "values",

  //   component: function() {
  //     return import(/* webpackChunkName: "about" */ "../views/ProfileValues.vue");
  //   }
  // },
  // {
  //   path: "/profile/our-standard-business-conduct",
  //   name: "conduct",

  //   component: function() {
  //     return import(/* webpackChunkName: "about" */ "../views/ProfileBusinessConduct.vue");
  //   }
  // },
  // {
  //   path: "/people/our-way-working",
  //   name: "work",

  //   component: function() {
  //     return import(/* webpackChunkName: "about" */ "../views/PeopleWayWorking.vue");
  //   }
  // },
  // {
  //   path: "/people/careers",
  //   name: "careers",

  //   component: function() {
  //     return import(/* webpackChunkName: "about" */ "../views/PeopleCareers.vue");
  //   }
  // },
  // {
  //   path: "/people/meet-our-people",
  //   name: "meetpeople",

  //   component: function() {
  //     return import(/* webpackChunkName: "about" */ "../views/PeopleMeet.vue");
  //   }
  // },

  // {
  //   path: "/key-industries",
  //   name: "keyindustries",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: function() {
  //     return import(/* webpackChunkName: "about" */ "../views/KeyIndustries.vue");
  //   }
  // }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
})

router.beforeEach((to, from, next) => {
  // If this isn't an initial page load.
  window.scrollTo(0, 0)
  if (to.name) {
    NProgress.start()
  }
  next()
})

router.afterEach(() => {
  // Complete the animation of the route progress bar.
  NProgress.done()
})

export default router
